import type CartItemInterface from '../constants/interfaces/cart-item-interface';
import type { CartItemType } from '../constants/types/cart-item';
import { removeTrailingZeros } from '../util/price-formatting';
import Product from './product';
import { toImgix } from '~/util/imgix';
type Props = {
  cartItem: CartItemType;
};

export default class CartItem implements CartItemInterface {
  cartItem: CartItemType;
  constructor(props: Props) {
    this.cartItem = props.cartItem;
  }

  get name() {
    if (this.isGiftCertificate) {
      return `Presentkort: ${this.cartItem.productName}`;
    } else {
      return this.cartItem.product.name;
    }
  }

  get brandName() {
    return this.cartItem.product.brandName;
  }

  get quantity() {
    return this.cartItem.quantity;
  }

  get totalPrice() {
    return removeTrailingZeros(this.cartItem.totalPrice);
  }

  get originalPrice() {
    return removeTrailingZeros(this.cartItem.totalPriceBeforeDiscount);
  }

  get showAsOnSale() {
    return this.product.showAsOnSale;
  }

  get item() {
    return this.cartItem.item;
  }

  get image() {
    if (
      !this.cartItem.product?.media ||
      Array.isArray(this.cartItem.product.media)
    ) {
      return 'https://placehold.co/514x567';
    } else {
      return toImgix(this.cartItem.product.media.standard[0]);
    }
  }

  get productId() {
    return this.cartItem.product.product;
  }

  get product() {
    return new Product({ ecomData: this.cartItem.product, contentData: null });
  }

  get line() {
    return this.cartItem.line;
  }

  get sku() {
    return this.cartItem.sku;
  }

  get isGiftCertificate() {
    return this.cartItem.brandName === 'Gift certificate';
  }

  get isExternalProduct() {
    return this.cartItem.brandName !== 'Ullmax';
  }
}
